import { useCallback } from 'react';
import { ToolbarItem, useToast, Button } from '@kinesis/bungle';
import { useInventoryId } from '@/hooks/use-inventory-id';
import { useExportGpcMutation } from '@/api/gpc';

const ToolbarGpc = () => {
  const [exportGpc, { isLoading: isExporting }] = useExportGpcMutation();
  const inventoryId = useInventoryId();
  const toast = useToast('globalTop');

  const onExport = useCallback(async () => {
    try {
      const data = await exportGpc({
        inventoryId,
      }).unwrap();
      window.location = data.url as any;
    } catch (e) {
      toast('Could not export GPC report.', { variant: 'error' });
    }
  }, [exportGpc, inventoryId, toast]);

  return (
    <ToolbarItem>
      <Button onClick={onExport} variant='secondary' loading={isExporting}>
        Export ZIP
      </Button>
    </ToolbarItem>
  );
};

export { ToolbarGpc };
